import { getRequest, postRequest } from '@bo-apis/axios';

const getPoNotificationList = ({ searchForm, pageable }) => {
  return postRequest({
    url: 'api/v1/po/customer-service/notification/get-notification-list',
    params: { ...pageable },
    data: { ...searchForm },
  });
};
const getPoNotificationDetail = (notificationNumber) => {
  return getRequest({
    url: `api/v1/po/customer-service/notification/${notificationNumber}`,
  });
};

export { getPoNotificationList, getPoNotificationDetail };
